// Visão "por meio de pagamento": método → white label → configurações.
//
// É o painel compartilhado com a dimensão do accordion escolhida — a visão por
// white label (Fase 2) é o mesmo componente com o outro `grouping`.
import { ProcessorConfigGroupedPanel } from "./processor-config-grouped-panel"

export const ProcessorConfigPanelByMethod = () => (
  <ProcessorConfigGroupedPanel grouping="byMethod" />
)
